import imagePlaceholder from '../assets/image-placeholder.svg';
/**
 * Generates a cropped image URL from the original image URL.
 *
 * This function modifies the provided image URL to include cropping parameters.
 * It assumes the presence of a "media/" segment in the URL as a reference point.
 *
 * @param url - The original image URL.
 * @returns The modified URL pointing to the cropped version of the image.
 */
export const getCroppedImageUrl = (url: string): string => {
	if (!url) return imagePlaceholder;

	const targetSegment = 'media/';
	const targetIndex = url.indexOf(targetSegment) + targetSegment.length;

	if (targetIndex <= targetSegment.length) return '';

	return `${url.slice(0, targetIndex)}crop/600/400/${url.slice(targetIndex)}`;
};
